<template>
    <div class="sup-type-switch-comp" :style="docs_type_switch_style">
        <div class="re-w1200 re-main-col">
            <div class="type-switch-btn-box">
                <div
                    class="switch-item"
                    :class="{ 'switch-item-active': item.isActive }"
                    v-for="(item, index) in typeList"
                    :key="index"
                    @click="type_switch_action(item)">
                    {{ item.name }}
                </div>
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onBeforeMount, computed, getCurrentInstance } from 'vue';
import { useRouterStore } from '@/stores/router';

const router_store = useRouterStore();
const { proxy } = getCurrentInstance();

const props = defineProps({
    title_name: String, // 标题
    currId: {
        type: Number,
        default: 101,
    }, //当前选中id
    bgClr: {
        type: String,
        default: 'var(--color-main-nav-dark-bg)',
    },
    docs_type_switch_click: Function, //点击回调
});

const typeList = ref(proxy.$globalObj.docs_switch_list); // 类型列表

const docs_type_switch_style = computed(() => {
    let styleStr = `background:${props.bgClr};`;
    return styleStr;
});

const docs_type_switch_class = computed(() => {
    return function (item) {
        let classStr = '';
        classStr = 'type-name type-name-clr';
        if (item.isActive) classStr = classStr + ' type-name-clr-active';
        return classStr;
    };
});
onBeforeMount(() => {
    typeList.value.forEach((e) => {
        e.isActive = false;
        if (e.id === props.currId) {
            e.isActive = true;
        }
    });
});

// MARK 类型选择
const type_switch_action = (item) => {
    props.docs_type_switch_click(item);
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-type-switch-comp {
    display: flex;
    align-items: center;
    margin: 0 auto;

    .type-switch-btn-box {
        position: relative;
        display: flex;
        width: 100%;

        .switch-item {
            position: relative;
            width: 93px;
            height: 35px;
            border-radius: 3px;
            font-size: 12px;
            line-height: 16px;
            font-weight: 400;
            display: flex;
            flex-shrink: 0;
            justify-content: center;
            align-items: center;
            margin-right: 30px;
            cursor: pointer;
            background: var(--color-main-dev-center-switch-item-bg);
            color: var(--color-main-text-dark-bg-primary);

            &:hover {
                background: var(--color-main-gradual-change-bg);
                color: var(--color-main-text-brand-bg-primary);
            }
        }

        .switch-item-active {
            background: var(--color-main-gradual-change-bg);
            color: var(--color-main-text-brand-bg-primary);
        }
    }
}
</style>
